import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";

interface SegmentListCardProps {
  resources: Array<{ title: string; id: string }>;
}

export const SegmentListCard = ({ resources }: SegmentListCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.community_segments")}
    resources={resources}
    emptyStateText={t(
      "help_widget.copilot.chat_card.no_community_segments_found",
    )}
    renderItem={segment => <span className="font-bold">{segment.title}</span>}
    getItemKey={segment => segment.id}
  />
);
